import React, { memo, useId, useRef } from 'react';
import Draggable from 'react-draggable';

import Button from '../../helpers/Button';
import useFocusTrap from '../../helpers/Popup/useFocusTrap';

import style from './style.module.css';

const DEFAULT_POSITION = {
  x: Math.floor((window.innerWidth - 600) / 2),
  y: Math.floor((window.innerHeight - 250) / 2),
};

/**
 * Popup for displaying general information.
 */
const TopLevelInfoPopup = ({ popup }) => {
  const { header, message, onClosePopupCallBack } = popup;
  const dialogRef = useRef(null);
  const titleId = useId();

  useFocusTrap(dialogRef);

  let errors = message.texts.message;

  if (Object.hasOwn(message.texts, 'errors')) {
    errors = (
      <ul>
        {message.texts.errors.map((error, index) => (
          <li key={index} className={message.className}>
            {error}
          </li>
        ))}
      </ul>
    );
  }

  return (
    <>
      <div className="modal-backdrop fade in" style={{ zIndex: 1051 }} />
      <div
        ref={dialogRef}
        aria-labelledby={titleId}
        aria-modal="true"
        className="move modal fade in"
        role="dialog"
        style={{ display: 'block', zIndex: 1051 }}
        tabIndex="-1"
      >
        <Draggable
          axis="both"
          bounds="parent"
          defaultPosition={DEFAULT_POSITION}
          handle=".handle-draggable"
          position={null}
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header truncate-text handle-draggable">
                <button aria-label="Close" className="close" onClick={onClosePopupCallBack} type="button">
                  <span aria-hidden="true">×</span>
                </button>
                <h4 className="modal-title" id={titleId}>
                  {header}
                </h4>
              </div>

              <div className="modal-body">
                <div className={style.errorContent}>{errors}</div>
              </div>

              <div className="modal-footer">
                <Button onClick={onClosePopupCallBack}>Close</Button>
              </div>
            </div>
          </div>
        </Draggable>
      </div>
    </>
  );
};

export default memo(TopLevelInfoPopup);
